import { createApi, createDomain } from 'effector';
import produce, { type Draft } from 'immer';
import { createGate } from 'effector-react';
import {
  type GeneralID,
  HSIconType,
  type Hotspot,
  type HotspotGroupItem,
  type HotspotGroups,
  type SceneType,
} from '@types';

const domain = createDomain('editingHotspot');

export interface EHStore {
  hotspot: Hotspot;
  sceneId: GeneralID;
  isNew?: boolean;
  isBatch?: boolean;
  batchHotspots?: Hotspot[];
  sceneType?: SceneType;
}

export const $editingHotspot = domain.store<EHStore | null>(null);
export const $editingHotspotApi = createApi($editingHotspot, {
  set: (state, payloed: EHStore | null) => payloed,
  clear: () => null,
  update: (state, updater: (draft: Draft<Hotspot>) => Hotspot | void) => {
    if (!state) return state;
    if (!state.isBatch) {
      const newData = produce(state.hotspot, updater);
      return { ...state, hotspot: newData };
    }
    if (state.batchHotspots) {
      const newData = produce(state.hotspot, updater);
      const newDatas = state.batchHotspots.map((x) => {
        const { ath, atv } = x.icon;
        const h = produce(x, updater);
        return {
          ...h,
          showTitle: h.icon.type === HSIconType.mark ? 1 : h.showTitle,
          icon: { ...h.icon, ath, atv },
        };
      });
      return { ...state, batchHotspots: newDatas, hotspot: newData };
    }
    return state;
  },
  updateBatch: (state, updater: Hotspot[]) => {
    if (!state) return state;
    if (!state.isBatch) return state;
    if (state.batchHotspots) {
      return {
        ...state,
        batchHotspots: updater,
      };
    }
    return state;
  },
});

export const $GateEditingGroup = createGate<{
  data: HotspotGroupItem;
  index: number;
} | null>({ defaultState: null, domain });

export const $GateGroupStyle = createGate<Pick<
  HotspotGroups,
  'bgColor' | 'fontColor' | 'activeBgColor' | 'activeFontColor'
> | null>({ defaultState: null, domain });
